export const sessionTypes = [
  {
    name: 'Talk',
    background: 'bg-red-50',
    text: 'text-red-700',
    border: 'ring-red-600/10',
    ball: 'fill-red-500',
    description: 'Speakers share their insights on particular topics, typically using a presentation.',
  },
  {
    name: 'Panel',
    background: 'bg-yellow-50',
    text: 'text-yellow-700',
    border: 'ring-yellow-600/20',
    ball: 'fill-yellow-500',
    description:
      'A group of people discuss a topic from different viewpoints. This enables people to delve deeper into any areas not covered in a talk.',
  },
  {
    name: 'Fireside',
    background: 'bg-teal-50',
    text: 'text-teal-700',
    border: 'ring-teal-600/20',
    ball: 'fill-teal-500',
    description: 'A person is interviewed about their experiences on a particular topic.',
  },
  {
    name: 'Debate',
    background: 'bg-pink-50',
    text: 'text-pink-700',
    border: 'ring-pink-700/10',
    ball: 'fill-pink-500',
    description:
      'Two people debate a topic form opposing viewpoints. This allows people to understand the context of when advice is relevant or not.',
  },
  {
    name: 'Forum',
    background: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'ring-blue-700/10',
    ball: 'fill-blue-500',
    description:
      'An unstructured conversation between attendees. A moderator can help to prompt people when necessary.',
  },
  {
    name: 'Q&A',
    background: 'bg-indigo-50',
    text: 'text-indigo-700',
    border: 'ring-indigo-700/10',
    ball: 'fill-indigo-500',
    description: 'A Q&A session with an industry leader.',
  },
  {
    name: 'Workshop',
    background: 'bg-purple-50',
    text: 'text-purple-700',
    border: 'ring-purple-700/10',
    ball: 'fill-purple-500',
    description: 'A hands-on run through of a particular topic. Turn the theory of the talks into practice.',
  },
  {
    name: 'Activity',
    background: 'bg-green-50',
    text: 'text-green-700',
    border: 'ring-green-600/20',
    ball: 'fill-green-500',
    description: 'A social activity to help encourage attendees to meet one another.',
  },
]
